(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canard-marca"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCmarcaReveal() {
      var root = document.querySelector('.cmarca');
      if (!root) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;

      var singles = ['.cmarca-pilares__head', '.cmarca-look__head'];
      var groups = ['.cmarca-hybrid', '.cmarca-manifesto__inner', '.cmarca-pilares__grid', '.cmarca-look__grid', '.cmarca-cta'];

      var targets = [];
      singles.forEach(function (sel) {
        root.querySelectorAll(sel).forEach(function (el) { targets.push(el); });
      });
      groups.forEach(function (sel) {
        var group = root.querySelector(sel);
        if (!group) return;
        Array.prototype.slice.call(group.children).forEach(function (el, i) {
          el.style.transitionDelay = (i * 0.09) + 's';
          targets.push(el);
        });
      });

      targets.forEach(function (el) { el.classList.add('reveal'); });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      targets.forEach(function (el) { io.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCmarcaReveal);
    } else {
      initCmarcaReveal();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canard-privacidade"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openAndScroll(hash) {
      if (!hash) return;
      var id = hash.replace('#', '');
      var target = document.getElementById(id);
      if (!target) return;
      if (target.tagName === 'DETAILS' && !target.open) {
        target.open = true;
      }
      requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    function initCprivIndex() {
      var root = document.querySelector('.cpriv');
      if (!root) return;

      root.querySelectorAll('.cpriv-index__list a').forEach(function (link) {
        link.addEventListener('click', function (e) {
          var href = link.getAttribute('href');
          if (!href || href.charAt(0) !== '#') return;
          var target = document.getElementById(href.slice(1));
          if (!target) return;
          e.preventDefault();
          openAndScroll(href);
          history.pushState(null, '', href);
        });
      });

      if (location.hash) openAndScroll(location.hash);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCprivIndex);
    } else {
      initCprivIndex();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canard-trocas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCtrocaReveal() {
      var root = document.querySelector('.ctroca');
      if (!root) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;

      var groups = ['.ctroca-stats__grid', '.ctroca-steps__grid', '.ctroca-cases__grid'];
      var targets = [];
      groups.forEach(function (sel) {
        var group = root.querySelector(sel);
        if (!group) return;
        Array.prototype.slice.call(group.children).forEach(function (el, i) {
          if (!el.classList.contains('reveal')) el.classList.add('reveal');
          el.style.transitionDelay = (i * 0.09) + 's';
          targets.push(el);
        });
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      targets.forEach(function (el) { io.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCtrocaReveal);
    } else {
      initCtrocaReveal();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cndv1-hero"] && !Shopify.designMode) return;
  try {
    
  /* Reveal on scroll (v1.0) — os elementos .reveal da home começam invisíveis */
  (function () {
    function initReveals() {
      var els = document.querySelectorAll('.reveal');
      if (!els.length) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        els.forEach(function (e) { e.classList.add('visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (e) { io.observe(e); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReveals);
    else initReveals();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cndv1-value-bar"]) return;
  try {
    
  (function () {
    function initHeaderOffsetSync() {
      var header = document.querySelector('header-component');
      var valuebar = document.querySelector('.cnd-valuebar-wrap');
      if (!header) return;

      function apply() {
        var h = header.getBoundingClientRect().height;
        var vb = valuebar ? valuebar.getBoundingClientRect().height : 0;
        if (h > 0) {
          document.documentElement.style.setProperty('--cnd-header-offset', h + 'px');
          document.documentElement.style.setProperty('--cnd-topbar-height', (h + vb) + 'px');
        }
      }

      apply();

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(apply);
        ro.observe(header);
        if (valuebar) ro.observe(valuebar);
      } else {
        window.addEventListener('resize', apply);
      }

      // O header pode mudar de altura ao virar "sticky-active" (modo compacto) — reobserva no scroll também.
      window.addEventListener('scroll', apply, { passive: true });
      window.addEventListener('load', apply);
    }

    function initValuebarLoop() {
      var track = document.querySelector('.cnd-valuebar-track');
      if (!track) return;

      // Técnica de "conteúdo duplicado + translateX(-1 cópia)" só é sem falhas se uma cópia
      // for pelo menos tão larga quanto a tela. Com poucos itens numa tela grande a cópia fica
      // mais estreita que o viewport e sobra um vão em branco no meio do loop. Fix: clonar
      // cópias extras até garantir largura de sobra, e mover a animação exatamente 1 cópia
      // (não mais -50% fixo, que só funciona com exatamente 2 cópias).
      function build() {
        var copies = Array.prototype.slice.call(track.querySelectorAll('.cnd-valuebar'));
        if (!copies.length) return;
        // remove clones de uma rodada anterior, mantém só as 2 cópias originais do Liquid
        for (var i = 2; i < copies.length; i++) { copies[i].remove(); }
        copies = copies.slice(0, 2);
        var template = copies[0];
        var singleWidth = template.getBoundingClientRect().width;
        if (singleWidth <= 0) return;

        var target = window.innerWidth * 2;
        var total = singleWidth * copies.length;
        while (total < target) {
          var clone = template.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
          total += singleWidth;
        }

        document.documentElement.style.setProperty('--cnd-valuebar-loop-distance', singleWidth + 'px');
        var pxPerSecond = 45;
        var duration = Math.max(singleWidth / pxPerSecond, 8);
        track.style.animationDuration = duration + 's';
      }

      build();
      var resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(build, 200);
      });
      window.addEventListener('load', build);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
    }

    function init() {
      initHeaderOffsetSync();
      initValuebarLoop();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
